/** Small branded acknowledgement of an active run; surrounding text owns its name. */
export function AssistantWorkingMark() {
  return <img src="/logo/scarlet-sync-no-bg.png" alt="" aria-hidden="true" width={24} height={24} className="ss-assistant-working-mark size-6 shrink-0 object-contain" />;
}
